export const UI_INPUT_JSON_DEFAULT_VALUE = '{"UIInputs":[]}';
export const UI_PREVIEW = 'UI Preview';
export const ASSISTANT_ID = 'assistant';
export const UI_INPUT_FILENAME = 'UIInput.json';
